import { FC, useMemo, useState } from "react";
import { ImageType } from "../helpers/useImages";
import closeImage from "../close-svgrepo-com.svg";
import useUser from "../helpers/useUser";
import useBuyImage from "../helpers/useBuyImage";

const ModalBuy: FC<{ image: ImageType }> = ({ image }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [user] = useUser();

  const { loading, error, buy } = useBuyImage();

  const totalPrice = useMemo<number>(() => {
    if(user && user.subscription.allowed) {
      return Math.round(image.price / 2);
    } else {
      return image.price;
    }
  }, [image.price, user]);

  if (image.bought)
    return (
      <button
        className={"yButton"}
        onClick={() =>
          window.open(
            `/ycore?module=magazine&mode=download&file_id=${image.id}&downloadStart=true`
          )
        }
      >
        Скачать
      </button>
    );
  return (
    <>
      {user && (
        <button className={"yButton"} onClick={() => setIsOpen(true)}>
          Купить
        </button>
      )}
      {isOpen && user && (
        <div className={"modal-wrapper"}>
          <div className={"modal-overlay"} onClick={() => setIsOpen(false)}>
            <img
              src={closeImage}
              className={"close-button"}
              onClick={() => setIsOpen(false)}
              alt={"Close"}
            />
          </div>
          <div className="modal-container">
            Покупка картинки № {image.id}
            <img
              src={`/ymaxiProduct/billing2/php/modules/magazine/files/imgtovar/${image.preview}`}
              alt={"Preview"}
            />
            <span>Стоимость - {totalPrice} р.</span>
            <span>Ваш баланс - {user.balance} р.</span>
            {user.balance >= totalPrice ? (
              <span className={"confirm"}>Подтвердите покупку</span>
            ) : (
              <NoMoneyBlock />
            )}
            {error && <span style={{ color: "red" }}>{error.message}</span>}
            <div>
              <button onClick={() => setIsOpen(false)}>Отмена</button>
              <button
                className={"yButton"}
                disabled={!user || user.balance < totalPrice}
                onClick={() => buy(image.id)}
              >
                {loading ? "Покупаем..." : "Подтверждаю"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const NoMoneyBlock: FC = () => {
  return (
    <div className={"no-money-block"}>
      <span>На вашем счете недостаточно средств</span>
      <a href="/billing-add-invoced.html" target={"_blank"}>
        Пополнить
      </a>
    </div>
  );
};

export default ModalBuy;
